<script setup>
import { ref } from 'vue'


//events raised by component
const emit = defineEmits(['closeIndModal'])

//peoperties set by parent
const props = defineProps({
	isOpen: {
		type: Boolean,
		default: false,
	},
	topic: {
		type: Object,
		required: true
	},
	subtopic: {
		type: Object,
		required: true
	}
})

//reactive field proxies
const topic = ref(props.topic)
const subtopic = ref(props.subtopic)

//local variables

//methods
function closeModal() {
	emit('closeIndModal');
}


defineExpose({
    openModal
});

function openModal() {

}

</script>

<template>
	<div v-if="props.isOpen" class="modal-overlay">
		<div class="modal-container">
			<div class="modal-header">
			{{props.subtopic.title}}
				<button class="btn-icon btn-close" @click="closeModal"><i class="fa-solid fa-times"></i></button>
			</div>
			<div class="modal-body">
				<div class="title">
					Indicators
				</div>
				<div class="list-container">
					<ul>
 						<li v-for="(indicator, index) in props.subtopic.indicators" :key="index">
							<router-link :to="{ name: 'ExplorerView', query: {iname: `${indicator.name}`}}">{{indicator.name}}</router-link>
						</li>
					</ul>					
				</div>
			</div>
		</div>
	</div>
</template>
   
<style scoped>
	.modal-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index:100
	}
  
	.modal-container {
		background-color: var(--surface-color-Default);
		display: flex;
		width: 48.25rem;
		min-height: 33rem; 
		padding: var(--spacing-0, 0rem);
		flex-direction: column;
		align-items: flex-start;
		gap: var(--spacing-3xl, 2.5rem);
		position: relative;
		z-index: 101;
		border-top-left-radius: var(--radius-xl);
		border-top-right-radius: var(--radius-xl);
		border-bottom-left-radius: var(--radius-xl);
		border-bottom-right-radius: var(--radius-xl);		
	}

	.modal-header {
		display: flex;
		height: 5rem;
		padding: 1.4375rem 2rem 1.5625rem 2rem;
		justify-content: space-between;
		align-items: center;
		align-self: stretch;
		border-bottom: 1px solid var(--borders-DividerActive, #064291);
		background: var(--surface-brand-Blue, #064291);
		color: var(--text-Inverse, #fff);
		font-family: var(--font-family-Title);
		font-size: var(--font-size-H5);
		border-top-left-radius: var(--radius-xl);
		border-top-right-radius: var(--radius-xl);	
	}

	.modal-body {
		background: var(--surface-Default, #FFF);
		min-height: 15.0625rem;
		display: flex;
		padding: 0rem var(--spacing-xl) var(--spacing-xl, 6rem) var(--spacing-xl);
		flex-direction: column;
		align-items: flex-start;
		align-self: stretch;	
	}

	.modal-footer {
		display: flex;
		padding: var(--spacing-lg, 1rem) var(--spacing-xl);
		justify-content: flex-end;
		align-items: flex-end;
		gap: var(--spacing-lg, 1rem);
		align-self: stretch;
		max-height: 5rem;

		border-top: 1px solid var(--border-color-Divider, #A9B7C7);
		background: var(--surface-default, #FFF);
		border-bottom-left-radius: var(--radius-xl);
		border-bottom-right-radius: var(--radius-xl);		
	}

	.title {
		color: var(--text-Primary, #2C2C2C);

		/* Regular/Base */
		font-family: var(--font-family-Title, Roboto);
		font-size: var(--font-size-H6);
		font-style: normal;
		font-weight: 400;
		line-height: var(--font-line-height-h6);
		display: block;
	}

	.btn-close {
		width: 1rem;
		color: var(--icons-icon-cta-reverse, #FFF);
		background: var(--surface-brand-Blue, #064291);
		font-size: 1.25rem;
		font-style: normal;
		font-weight: 900;
		line-height: normal;
		border: 0;
  	}

	.list-container {
		height: 18.75rem;;
		width: 43.75rem;;
		overflow-y: auto;
	}

	ul {
		padding: 0;
	}

	li {
		list-style-type: none;
		padding: 4px 0;
	}

	a {
		text-decoration: none;
		color: var(--text-Link);
	}
</style>